import { Box, Card, CardContent, Grid } from "@material-ui/core";
import * as React from "react";
import { Edit, FormWithRedirect, required, TextInput, Toolbar } from "react-admin";
import { useVerifyPermission } from "@airborne/react-admin";

const ShippingAddressEdit = props => {
  useVerifyPermission("shippingaddresss", "edit");
  return (
    <Edit title={"Shipping Address Edit"} component="div" {...props}>
      <FormWithRedirect
        {...props}
        render={(formProps: any) => {
          return (
            <Card>
              <form>
                <CardContent>
                  <Grid container spacing={2} direction="row">
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <TextInput
                        validate={required()}
                        disabled={true}
                        source="customer.ownerCode"
                        label="Customer"
                        fullWidth
                        style={{ marginRight: "8px" }}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <TextInput
                        validate={required()}
                        disabled={true}
                        source="airportCode"
                        label="Airport Code"
                        fullWidth
                        style={{ marginRight: "8px" }}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <TextInput
                      validate={required()}
                      source="attentionName"
                      label="Attention Name"
                      fullWidth
                      style={{ marginRight: "8px" }}
                      variant="outlined"
                    />
                    <TextInput
                      validate={required()}
                      source="attentionPhone"
                      label="Attention Phone"
                      fullWidth
                      style={{ marginLeft: "8px" }}
                      variant="outlined"
                    />
                  </Box>

                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <TextInput
                      validate={required()}
                      source="consigneeName"
                      label="Company/Consignee Name"
                      fullWidth
                      style={{ marginRight: "8px" }}
                      variant="outlined"
                    />
                    <TextInput
                      validate={required()}
                      source="email"
                      label="E-mail"
                      type="email"
                      fullWidth
                      style={{ marginLeft: "8px" }}
                      variant="outlined"
                    />
                  </Box>

                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <TextInput
                      validate={required()}
                      source="consigneeAddress"
                      label="Company/Consignee Address"
                      fullWidth
                      style={{ marginRight: "8px" }}
                      multiline
                      resettable
                      variant="outlined"
                    />
                    <TextInput
                      validate={required()}
                      source="shipAddress"
                      label="Shipping Address"
                      fullWidth
                      style={{ marginLeft: "8px" }}
                      multiline
                      resettable
                      variant="outlined"
                    />
                  </Box>
                </CardContent>
                <Toolbar
                  {...props}
                  placeholder=""
                  record={formProps.record}
                  basePath={formProps.basePath}
                  undoable={true}
                  invalid={formProps.invalid}
                  handleSubmit={formProps.handleSubmit}
                  saving={formProps.saving}
                  resource="shippingaddresss"
                />
              </form>
            </Card>
          );
        }}
      />
    </Edit>
  );
};

export default ShippingAddressEdit;
